import { string } from "prop-types";

import styled from "styled-components";

const SInput = styled("input")`
  height: 0px;
  width: 0px;
  opacity: 0;
  border-width: 0px;
  padding: 0px;
`;

/**
 *
 * @param {object} param0
 * @param {string} param0.value - the value of the input to be submitted with the form.
 * @param {string} param0.autoComplete - any valid autocomplete string to be passed down to the input
 * @returns
 */
const FauxInput = ({ value, autoComplete, ...rest }) => (
  <SInput
    readOnly
    tabIndex={-1}
    value={value}
    autoComplete={autoComplete}
    {...rest}
  />
);

FauxInput.propTypes = { value: string, autoComplete: string };

export default FauxInput;
